import Fab from "./Fab";

export default Fab;
